import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/customers/create')({
  component: CreateCustomerRedirect,
})

function CreateCustomerRedirect() {
  // Redirect to customers list - creation is now handled via CustomerDrawer
  return <Navigate to='/customers' />
}
